import React, { useState } from "react";
import gamersWalletLogo from "../../assets/images/gamerslogo.png";
import togglerIcon from "../../assets/images/toggler-icon.png";
import { NavLink } from "react-router-dom";
import "./NavBar.css";
import { Dropdown, Select, Drawer, Menu } from "antd";
import { AiFillCaretDown } from "react-icons/ai";
import DownloadButton from "../Buttons/DownloadButton";
import { useTranslation } from "react-i18next";
const NavBar = () => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const items = [
    {
      label: (
        <a href="/#trade" onClick={onClose}>
          {t("Trade")} {t("in")} {t("Game")} {t("Assets")}
        </a>
      ),
      key: "0",
    },
    {
      label: (
        <a href="/#connect" onClick={onClose}>
          {t("Connect")} {t("to")} {t("thirdparty")}
        </a>
      ),
      key: "1",
    },
    {
      label: (
        <a href="#cryptocard" onClick={onClose}>
          {t("Crypto")}-{t("Card")}
        </a>
      ),
      key: "2",
    },
    {
      label: (
        <a onClick={onClose} href="#authentication">
          {t("Authentication")}
        </a>
      ),
      key: "3",
    },
  ];
  const handleChange = (value) => {
    console.log(`Selected ${value}`);
    i18n.changeLanguage(value);
  };
  function getItems(label, key, children, type) {
    return {
      key,
      children,
      label,
      type,
    };
  }
  const rootSubmenuKeys = ["sub1"];
  const navItems = [
    getItems("Features", "sub1", [
      getItems(
        <a href="/#trade" onClick={onClose}>
          {t("Trade")} {t("in")} {t("Game")} {t("Assets")}
        </a>
      ),
      getItems(
        <a href="/#connect" onClick={onClose}>
          {t("Connect")} {t("to")} {t("thirdparty")}
        </a>
      ),
      getItems(
        <a href="#cryptocard" onClick={onClose}>
          {t("Crypto")}-{t("Card")}
        </a>
      ),
      getItems(
        <a onClick={onClose} href="#authentication">
          {t("Authentication")}
        </a>
      ),
    ]),
  ];
  const [openKeys, setOpenKeys] = useState([]);
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  return (
    <header className="navbar-container">
      <div className="navbar-details">
        <div className="logo">
          <a href="/">
            <img src={gamersWalletLogo} alt="Sportrex Logo" />
          </a>
        </div>
        <div className="nav-menu">
          <ul>
            <Dropdown
              menu={{
                items,
              }}
              trigger={["click"]}
              placement="bottom"
            >
              <li onClick={(e) => e.preventDefault()}>
                {t("Features")} <AiFillCaretDown className="dropdown-icon" />
              </li>
            </Dropdown>
            <li>
              <a
                href="https://medium.com/@sportrex"
                target="_blank"
                rel="noreferrer"
                className="nav-links"
              >
                Blog
              </a>
            </li>
            <li>
              <NavLink
                to="/faq"
                className="nav-links"
                style={({ isActive }) => ({
                  color: isActive ? "#FFF" : "#ABABAB",
                })}
              >
                FAQ
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="nav-dropdown-button">
          <Select
            defaultValue={"ENG"}
            style={{
              width: "100%",
            }}
            onChange={handleChange}
            options={[
              {
                value: "ENG",
                label: "ENG",
              },
              {
                value: "FRA",
                label: "FRA",
              },

              {
                value: "CHN",
                label: "CHN",
              },
              {
                value: "ARB",
                label: "ARB",
              },
              {
                value: "SPA",
                label: "SPA",
              },
              {
                value: "POR",
                label: "POR",
              },
              {
                value: "GER",
                label: "GER",
              },
              {
                value: "DUT",
                label: "DUT",
              },
            ]}
            className="select-option"
          ></Select>
          <DownloadButton />
        </div>
        <div className="toggler-button" onClick={showDrawer}>
          <img src={togglerIcon} alt="Toggler button" />
        </div>
      </div>
      <Drawer
        placement="top"
        onClose={onClose}
        open={open}
        className="mobile-drawer"
        title={
          <div className="logo">
            <a href="/">
              <img src={gamersWalletLogo} alt="Sportrex Logo" />
            </a>
          </div>
        }
      >
        <ul className="mobile-nav-links">
          {/* <Dropdown
            menu={{
              items,
            }}
            trigger={["click"]}
             placement="bottom"
          >
            <li onClick={(e) => e.preventDefault()}>
              {t("Features")} <AiFillCaretDown className="dropdown-icon" />
            </li>
          </Dropdown> */}
          <Menu
            mode="inline"
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            style={{
              width: 256,
            }}
            items={navItems}
          />
          <li>
            <NavLink
              onClick={onClose}
              to="/faq"
              className="nav-links"
              style={({ isActive }) => ({
                color: isActive ? "#FFF" : "#ABABAB",
              })}
            >
              FAQ
            </NavLink>
          </li>
          <li>
            <a
              href="https://medium.com/@sportrex"
              target="_blank"
              rel="noreferrer"
              className="nav-links"
            >
              Blog
            </a>
          </li>
        </ul>
      </Drawer>
    </header>
  );
};

export default NavBar;
